import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle, Mail } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import PageHeader from '../common/PageHeader';
import Footer from '../common/Footer';

const Support = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PageHeader />

      <div className="container py-12 md:py-12">
        <div className="mx-auto flex max-w-[980px] flex-col items-center gap-4 text-center mb-16">
          <Badge variant="outline">Support</Badge>
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
            Vi är här för att hjälpa dig
          </h1>
          <p className="max-w-[750px] text-lg text-muted-foreground">
            Har du frågor eller behöver hjälp? Kontakta oss så återkommer vi så snart som möjligt.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 max-w-3xl mx-auto">
          <Card>
            <CardHeader>
              <Mail className="h-8 w-8 mb-2" />
              <CardTitle>E-post</CardTitle>
              <CardDescription>Skicka oss ett meddelande</CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" asChild>
                <a href="mailto:info@dekalio.nu">info@dekalio.nu</a>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <HelpCircle className="h-8 w-8 mb-2" />
              <CardTitle>FAQ</CardTitle>
              <CardDescription>Vanliga frågor och svar</CardDescription>
            </CardHeader>
            <CardContent>
              <Button variant="outline" className="w-full" onClick={() => navigate('/faq')}>
                Besök FAQ
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Support;

